import { RiCloseLine } from "@itandi/itandi-bb-ui";
import cx from "clsx";
import type React from "react";
import ReactModal from "react-modal";
import Styles from "./Modal.module.scss";

type Props = {
	bodyClassName?: string;
	children: React.ReactNode;
	footers?: React.ReactNode;
	handleClose?: () => void;
	isOpen: boolean;
	shouldCloseOnOverlayClick?: boolean;
	size?: "lg" | "md";
	title: string;
};

ReactModal.setAppElement("body");

const customStyles = {
	content: {
		background: "none",
		border: "none",
		inset: 0,
		overflow: "hidden",
		padding: "0",
		width: "100%"
	},
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		zIndex: 10
	}
};

export function Modal({
	isOpen,
	children,
	handleClose,
	title,
	footers,
	size = "md",
	shouldCloseOnOverlayClick = false,
	bodyClassName = ""
}: Props) {
	const getSizeClass = (): string => {
		switch (size) {
			case "lg":
				return Styles.LargeSize;
			case "md":
				return Styles.MediumSize;
			default:
				return Styles.MediumSize;
		}
	};

	return (
		<ReactModal
			isOpen={isOpen}
			onRequestClose={handleClose}
			shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
			style={customStyles}
		>
			<div className={cx(Styles.ModalDialog, getSizeClass())}>
				<div className={Styles.ModalContent}>
					<header className={Styles.ModalHeader}>
						<div>{title}</div>
						{handleClose !== null && (
							<div className={Styles.ModalClose}>
								<button
									className={Styles.ModalCloseButton}
									onClick={handleClose}
									type="button"
								>
									<RiCloseLine className={Styles.CloseIcon} />
								</button>
							</div>
						)}
					</header>
					<div className={cx(Styles.ModalBody, bodyClassName)}>{children}</div>
					{footers ? <div className={Styles.ModalFooter}>{footers}</div> : null}
				</div>
			</div>
		</ReactModal>
	);
}
